import { date, number, object, string } from 'yup';
import { ManagerDataSharingOption } from '../types/userTypes';
import { CountryCode, EndDate, Entitlement, KnownAsName, ManagerEmail, ManagerName, ManagerSharingDataOption, RegionCode, } from '../UserDataManagement';
const MaxNameLength = 75;
const RequiredMessage = 'This field is required';
const NameTooLong = `Name can have up to ${MaxNameLength} characters`;
const CharactersNotAllowed = 'Name can not contain the following characters \\/<>:.#';
const EmailNotValid = 'Value has to be a valid email';
export const holidayYearFormSchemaFunc = () => object({
    [EndDate]: date().required(RequiredMessage),
    [Entitlement]: number().required(RequiredMessage),
    [ManagerEmail]: string().email(EmailNotValid),
    [ManagerName]: string()
        .max(MaxNameLength, NameTooLong)
        .matches(/[^\\/<>:.\t\n\r#]+$/, CharactersNotAllowed)
        .notRequired(),
    [KnownAsName]: string()
        .max(MaxNameLength, NameTooLong)
        .matches(/[^\\/<>:.\t\n\r#]+$/, CharactersNotAllowed)
        .notRequired(),
    [RegionCode]: string(),
    [CountryCode]: string(),
    [ManagerSharingDataOption]: number()
        .oneOf([
        ManagerDataSharingOption.AllHistoricData,
        ManagerDataSharingOption.CurrentEntitlementYear,
    ])
        .required(RequiredMessage),
});
const holidayYearFormSchema = holidayYearFormSchemaFunc();
